<template>
    <table v-if="data" class="table">
        <thead>
            <tr>
                <th>Name</th>
                <th>Id</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in data" :key="row.Id">
                <td>{{ row.Name }}</td>
                <td>{{ row.Id }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
const { data } = await useApi<{ Id: number; Name: string }[]>("docs/distributors");
</script>
